export enum LanguageType {
    SPANISH = 'es',
    FRANCOIS = 'fr',
}
